import { SvgIconType } from './svg.interface';

const Phone: SvgIconType = ({
  width = 12,
  height = 12,
  className = '',
  color = '#A3ACBA'
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5918 11.25C4.99332 11.2579 0.7441 6.95812 0.750006 1.40822C0.750006 1.04531 1.04401 0.75 1.40626 0.75H3.13875C3.4636 0.75 3.73988 0.988875 3.78779 1.31044C3.90204 2.08157 4.12636 2.83231 4.45388 3.53972L4.52147 3.6854C4.56688 3.78344 4.57664 3.89425 4.54909 3.99872C4.52154 4.10319 4.45839 4.19476 4.37054 4.25765C3.83372 4.6409 3.62897 5.412 4.047 6.01312C4.57331 6.76999 5.23019 7.42709 5.98688 7.95365C6.58866 8.37102 7.35975 8.16627 7.74235 7.63012C7.80517 7.542 7.89682 7.47862 8.00144 7.45093C8.10606 7.42325 8.21707 7.43301 8.31525 7.47852L8.46028 7.54546C9.16772 7.87359 9.91847 8.09802 10.6896 8.21221C11.0111 8.26012 11.25 8.5364 11.25 8.8619V10.5937C11.25 10.68 11.233 10.7654 11.2 10.845C11.167 10.9247 11.1186 10.9971 11.0576 11.058C10.9965 11.119 10.9241 11.1673 10.8444 11.2002C10.7647 11.2332 10.6793 11.2501 10.5931 11.25H10.5918Z"
      fill={color}
    />
  </svg>
);

export default Phone;
